/* Bulltong - free-delivery meter. One component (snippets/free-delivery-meter.liquid), kept live here.
   Threshold comes from each element's data-threshold (theme setting); totals are cents. No literals. */
(function () {
  'use strict';
  var B = window.Bulltong = window.Bulltong || {};
  function money(cents) { cents = Math.round(cents); return 'AED ' + (cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2)); }
  function selection(el) {
    var prices = {};
    try { prices = JSON.parse(el.getAttribute('data-prices') || '{}'); } catch (e) { return 0; }
    var form = el.closest('form') || document.querySelector('form[data-product-form].pdp__form');
    if (!form) return 0;
    var idEl = form.querySelector('[name="id"]:checked') || form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var price = idEl ? Number(prices[idEl.value]) : 0;
    return price > 0 ? price * qty : 0;
  }
  function paint(el, total, opts) {
    var threshold = Number(el.getAttribute('data-threshold')) || 0;
    if (!threshold) return;
    total = Math.max(0, Number(total) || 0);
    var ctx = el.getAttribute('data-fdm');
    var add = ctx === 'pdp' ? selection(el) : 0;
    var sum = total + add, left = threshold - sum;
    var pct = Math.max(0, Math.min(100, Math.round(sum * 100 / threshold)));
    var msg;
    if (sum <= 0) msg = 'Free Dubai delivery over ' + money(threshold);
    else if (add > 0) msg = left > 0 ? "Add this and you're " + money(left) + ' away from free Dubai delivery' : 'Add this and Dubai delivery is free';
    else msg = left > 0 ? money(left) + ' away from free Dubai delivery' : 'Free Dubai delivery unlocked';
    if (opts && opts.suffix && left > 0 && sum > 0) msg += opts.suffix;
    var text = el.querySelector('[data-fdm-text]'), fill = el.querySelector('[data-fdm-fill]'), bar = el.querySelector('[role="progressbar"]');
    if (text) text.textContent = msg;
    if (fill) fill.style.width = pct + '%';
    if (bar) bar.setAttribute('aria-valuenow', String(pct));
    el.classList.toggle('is-free', sum > 0 && left <= 0);
    if (ctx === 'sticky') el.hidden = total <= 0;
  }
  var meter = B.meter = {
    total: 0,
    money: money,
    paint: paint,
    update: function (total) {
      if (total != null && !isNaN(total)) meter.total = Math.max(0, Number(total));
      var els = document.querySelectorAll('[data-fdm]');
      for (var i = 0; i < els.length; i++) if (els[i].getAttribute('data-fdm') !== 'pick') paint(els[i], meter.total);
    },
    refresh: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) meter.update(Number(cart.total_price) || 0); })
        .catch(function () {});
    }
  };
  function later() { setTimeout(function () { meter.update(); }, 0); }
  document.addEventListener('bulltong:cart-updated', function (e) { meter.update(Number(e.detail && e.detail.total) || 0); });
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('form[data-product-form]')) later(); });
  document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') later(); });
  document.addEventListener('product:variant-change', later);
  window.addEventListener('pageshow', function (e) { if (e.persisted) meter.refresh(); });
  function init() {
    var first = document.querySelector('[data-fdm]:not([data-fdm="pick"])');
    if (first) meter.update(Number(first.getAttribute('data-total')) || 0);
    document.dispatchEvent(new CustomEvent('bulltong:meter-ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
